export default "__VITE_ASSET__Djs1QO8E__"